import request from '@utils/request';
import url from '@utils/url';
const { HOST } = url
// const TEST_HOST = 'http://10.1.0.85:39003'

export async function channelList(params) {
    const url = ` ${HOST}/cps-gateway/api/v1/channel/group/list`;
    // const url = ` ${TEST_HOST}/cps-gateway/api/v1/channel/group/list`;
    return request({ method: 'get', url: url }, params);
}

export async function addChannel(params) {
    const url = ` ${HOST}/cps-gateway/api/v1/channel/group/create`;
    // const url = ` ${TEST_HOST}/cps-gateway/api/v1/channel/group/create`;
    return request({ method: 'post', url: url }, params);
}

export async function updateChannel(params) {
    const url = ` ${HOST}/cps-gateway/api/v1/channel/group/update`;
    // const url = ` ${TEST_HOST}/cps-gateway/api/v1/channel/group/update`;
    return request({ method: 'post', url: url }, params);
}

export async function deleteChannel(params) {
    const url = ` ${HOST}/cps-gateway/api/v1/channel/group/delete`;
    return request({ method: 'post', url: url }, params);
}

export async function getChannelCode() {
    const url = ` ${HOST}/cps-gateway/api/v1/channel/group/gen/code`;
    return request({ method: 'get', url: url });
}

export async function download(data) {
    const url = `${HOST}/cps-gateway/api/v1/channel/group/download_list_data`;
    
    return request({ method: 'get', url: url, responseType: 'blob' }, data);
}